/**
 * The intro player, now a thin wrapper over the generic cutscene player
 * (`shell/cutscene/cutscene-player.ts`): it supplies the two things that are
 * genuinely `TITLE.TTM`-specific — the hand-measured song cue table
 * (`songCueAt`/`INTRO_SONG_CUES`, `intro-machine.ts`) instead of the generic
 * "play on load" default, and `TITLE.SNG`'s own looping — and otherwise
 * changes nothing about how a frame is sequenced, drawn or sounded. This is
 * what keeps the intro byte-identical to before the cutscene surface was
 * factored out: the render/sequencing code it runs is the exact same code
 * the other five cutscenes now also run, just with `TITLE.TTM`'s own
 * command stream, which never reaches any of the branches the other five
 * scripts need (see `cutscene-stage.ts`'s header).
 */

import { createCutscenePlayer, type CutscenePlayer, type CutscenePlayerDeps } from "../cutscene/cutscene-player.ts";
import { songCueAt } from "./intro-machine.ts";

export type IntroPlayer = CutscenePlayer;

export type IntroPlayerDeps = Omit<CutscenePlayerDeps, "songCueAt" | "loopMusic">;

export function createIntroPlayer(deps: IntroPlayerDeps): IntroPlayer {
  return createCutscenePlayer({
    ...deps,
    songCueAt: (tickIndex) => songCueAt(tickIndex),
    loopMusic: (song) => song === "TITLE",
  });
}
